import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import config from '@/config';
import api from '@/shared/api';
import DataCacheService from '@/shared/services/DataCacheService';
import ToastrService from '@/shared/services/ToastrService';
import { useIntl } from 'react-intl';
import moment from 'moment';
import DocumentDetailsModal from './details/DocumentDetailsModal';
import messages from './documentMessages';

const ForcedRelationMode = ({ onDocumentSaved }) => {
  const [documents, setDocuments] = useState([]);
  const intl = useIntl();

  useEffect(() => {
    let abort = false;
    const cancelToken = Axios.CancelToken.source();
    const isRelationRequired =
      DataCacheService.getDefaultCompany()?.forceLinkingDocumentsToRelation ?? false;

    if (!isRelationRequired) return;

    const date = DataCacheService.getDefaultCompany()?.forceLinkingDocumentsToRelationFromDate;
    const formattedDate = date ? moment(date).format('YYYY-MM-DD') : null;

    api.base
      .get(`${config.appUrls.documents}/api/documents/Unlinked`, {
        params: {
          date: formattedDate,
        },
        cancelToken: cancelToken.token,
      })
      .then(({ data }) => {
        if (abort || !data) return;
        setDocuments(data || []);
      });

    return () => {
      abort = true;

      cancelToken.cancel('Operation canceled due to new request.');
    };
  }, []);

  const removeDocumentFromList = document => {
    setDocuments(documents.filter(x => x !== document.id));
    onDocumentSaved(document);
  };
  const cancel = () => {
    ToastrService.info(intl.formatMessage(messages.ForcedRelationModeCancelledMessage));
    setDocuments([]);
  };

  if (documents.length === 0) return null;

  const activeDocument = documents[0];
  return (
    <div key={activeDocument}>
      <DocumentDetailsModal
        show
        documentId={activeDocument}
        allowNavigation={false}
        onSave={document => removeDocumentFromList(document)}
        onClose={() => cancel()}
        forceRelationMode
      />
    </div>
  );
};

export default ForcedRelationMode;
